import React from "react";

import RestaurantLocator from "./shopLocator/restaurantLocator";
import StoreLocator from "./shopLocator/storeLocator";

const ShopLocator = ({ store, cmpnyIntroduce }) => {
  return (
    <>
      <RestaurantLocator store={store} />
      <StoreLocator cmpnyIntroduce={cmpnyIntroduce} />
    </>
  );
};

export default ShopLocator;
